// Collegiate Hero Slideshow
document.querySelectorAll('.collegiate-hero').forEach(function (hero) {
  const slides = hero.querySelectorAll('.collegiate-hero__slide');
  const dots   = hero.querySelectorAll('.collegiate-hero__dot');
  const speed  = (parseInt(hero.dataset.autoplay, 10) || 5) * 1000;

  if (slides.length < 2) return;

  let current = 0;
  let timer;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
  }

  function next() { goTo(current + 1); }

  function startTimer() { timer = setInterval(next, speed); }
  function resetTimer() { clearInterval(timer); startTimer(); }

  // Dot clicks
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      resetTimer();
    });
  });

  // Clicking the slideshow image navigates to the collection page
  var link = hero.dataset.link;
  if (link) {
    hero.addEventListener('click', function (e) {
      if (!e.target.closest('.collegiate-hero__dots') && !e.target.closest('.collegiate-hero__overlay-btn-wrap')) {
        window.location.href = link;
      }
    });
    hero.style.cursor = 'pointer';
  }

  startTimer();
});
